import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getTrackReplies } from "../api/getTrack";
import LoadMoreContainer from "./LoadMoreContainer";
import LoadMore from "../Components/Elements/LoadMore";

import { COMMENTS_PER_PAGE } from "../totdConfig";
import TrackComment from "../Components/Elements/TrackComment";
import TrackCommentsForm from "../Components/Elements/Forms/TrackCommentsForm";

class TrackCommentsContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: "comment", filter: this.props.filter, items: [] };
  }
  fetch = () => {
    this.props.request(this.state.filter, this.state.page).then(({ data }) => {
      const hasMore = data && data.length === COMMENTS_PER_PAGE;
      const items = this.state.items.slice(0);
      data.map((t) => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
  setReplies = (replies) => {
    this.setState({ ...this.state, items: replies });
  };
  render = () => {
    const { items, hasMore } = this.state;
    const { loading, track } = this.props;
    return (
      <React.Fragment>
        <p>Add a comment...</p>

        <TrackCommentsForm track={track} onReply={(replies) => (replies = this.setReplies(replies))} />

        {!loading && items.length > 0 && track && (
          <div className="totd-header">
            <h3>
              Comments for &ldquo;<span>{track.title}</span>&rdquo; by <span>{track.artist}</span>
            </h3>
          </div>
        )}
        {items &&
          items.map((comment) => (
            <div key={comment.id}>
              <TrackComment addRe={this.state.addRe} comment={comment} type={`comment`} highlight={this.state.filter} />
            </div>
          ))}

        <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} />
      </React.Fragment>
    );
  };
}

export default CreateContainer(getTrackReplies, TrackCommentsContainer);
